
import TableList from "@components/templates/tablelist";
import compAdd from "./add.vue";
import compUpdate from "./update.vue";
import compEditService from "./editservice.vue";
import mixin from "./mixin";
import {
    HttpCarrierAccountList,
    HttpActiveCarrier
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate,
        compAdd,
        compEditService
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'EQ_status': null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpCarrierAccountList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                console.log(item, this.formData.search[item])
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierGroup/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break
                case "edit":
                    let url = this.$router.resolve({
                        name: 'CarrierAccountUpdate',
                        params: { type: 'edit' },
                        query: { id: params }
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('global.common.operation_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compAdd",
                        activeid: params,
                        type: 1,
                        showFooter: false
                    }
                    break;
                case 'addGroupAccount':
                    this.operate = {
                        title: this.$t('fbb.carrieraccount.add_group_carrier', { defaultValue: '添加分组物流商' }),
                        show: true,
                        width: 600,
                        component: "compAdd",
                        activeid: params,
                        type: 2,
                        showFooter: false
                    };
                    break;
                case 'inActive':
                    this.operate = {
                        title: this.$t('global.common.failure', { defaultValue: '失效' }),
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        ajaxRequest: HttpActiveCarrier
                    };
                    break;
                case 'active':
                    this.operate = {
                        title: this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        ajaxRequest: HttpActiveCarrier
                    };
                    break;
                case 'editServiceConfig':
                    this.operate = {
                        title: this.$t('fbb.carrieraccount.edit_service_config', { defaultValue: '编辑服务配置' }),
                        show: true,
                        width: 600,
                        component: 'compEditService',
                        showFooter: false,
                        // params: { id: params }
                        id: params
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: this.handleAuth('fbb.carriergroup.query'),
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                show: this.handleAuth('fbb.carriergroup.edit'),
                to: {
                    name: "CarrierAccountUpdate",
                    params: {
                        type: 'edit',
                    },
                    query: { id }
                },

            }, {
                label: this.$t('global.common.failure', { defaultValue: '失效' }),
                show: this.handleAuth('fbb.carriergroup.edit') && row.active === 0,
                params: id,
                operate: 'inActive'
            }, {
                label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                show: this.handleAuth('fbb.carriergroup.edit') && row.active === 1,
                params: id,
                operate: 'active'
            }, {
                label: this.$t('fbb.carrieraccount.edit_service_config', { defaultValue: '编辑服务配置' }),
                show: this.handleAuth('fbb.carriergroup.editservice'),
                params: id,
                operate: 'editServiceConfig'
            }]
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAll",
            "getBillcusWareList",
            "getCountryList"
        ]),
        productStatus () {
            return [
                {
                    label: this.$t('erp.product.available', { defaultValue: '可用' }),
                    value: 1
                },
                {
                    label: this.$t('global.common.inactive', { defaultValue: '停用' }),
                    value: 0
                }
            ]
        },
        supplyStatus () {
            return [
                {
                    label: this.$t('erp.product_status.normal', { defaultValue: '正常补货' }),
                    value: 1
                },
                {
                    label: this.$t('erp.product_status.error', { defaultValue: '不再补货' }),
                    value: 0
                }
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: "添加" }),
                    operate: "add",
                    show: this.handleAuth('fbb.carriergroup.add'),
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.carriergroup.export'),
                    theme: 'success'
                },
                {
                    name: this.$t('fbb.carrieraccount.add_group_carrier', { defaultValue: '添加分组物流商' }),
                    operate: 'addGroupAccount',
                    show: this.handleAuth('fbb.carriergroup.addgroup'),
                    theme: 'primary'
                }
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'EQ_active',
                    show: true,
                    tag: 'vSelect',
                    options: [{
                        value: 0,
                        label: 'Active'
                    }, {
                        value: 1,
                        label: 'InActive'
                    }]
                },
                {
                    label: this.$t('fbb.carrieraccount.logistics_carrier', { defaultValue: '物流商' }),
                    key: 'CN_groupName',
                    show: true,
                    // tag: 'vInput',
                    tag: 'Input',
                },
                {
                    label: this.$t('fbb.carrieraccount.carrieraccount', { defaultValue: '承运商' }),
                    tag: 'Select',
                    options: this.getCarrierAll,
                    show: true,
                    key: 'IN_carrierCode',
                }
            ]
        },
        columns() {
            return [
                {
                    // show: false,
                    type: 'index',
                    width: 40,
                    align: 'center',
                }, {
                    title: '操作',
                    width: 70,
                    render: this.getOperateNodes,
                },{
                    title: this.$t('fbb.carrieraccount.logistics_carrier', { defaultValue: '物流商' }),
                    key: 'groupName'
                },{
                    title:this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key:'regionCode',
                    render:(h,{row})=>{
                        const region=this.getCountryList.filter(item=>item.value===row.regionCode)[0]
                        return (
                            <div>{region ? region.label : '--'}</div>
                        )
                    }
                },
                {
                    title: this.$t('fbb.carrieraccount.carrieraccount', { defaultValue: '承运商' }),
                    render: (h, { row }) => {
                        let carrierItem = this.getCarrierAll.filter(item => {
                            return item.value === row.carrierCode
                        })[0];
                        return (
                            <div>{carrierItem ? carrierItem.label : '--'}</div>
                        )
                    }
                },
                {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'active',
                    render: (h, { row }) => {
                        return row.active == 0 ? 'Active' : 'inActive';
                    }
                },
                {
                    title: 'Update Time',
                    key: 'updatedAt',
                    // width: 130
                }
            ];
        },

    }

};
